<template>
  <div :class="{ 'zy-service-container': versionConfig.ZHIYUN_VERSION }">
    <a-spin :spinning="spinning" class="wrap">
      <a-layout class="service-room-box">
        <a-layout>
          <div class="operater-section">
            <div>
              <a-button
                type="primary"
                @click="setDirty"
                :disabled="!canSetDirty"
                >置脏</a-button
              >
              <a-button
                type="primary"
                @click="appointCleaner"
                :disabled="!canAppointer"
                >派工</a-button
              >
              <a-button type="primary" @click="startClean" :disabled="!canClean"
                >开始清洁</a-button
              >
              <a-button
                type="primary"
                @click="endClean"
                :disabled="!canEndClean"
                >完成清洁</a-button
              >
              <a-button
                type="primary"
                @click="acceptClean"
                :disabled="!canAccept"
                >清洁确认</a-button
              >

              <a-button
                type="danger"
                @click="cancelClean"
                :disabled="!canCancel"
                >取消派工</a-button
              >
            </div>

            <div>
              <a-button type="primary" @click="reflesh">刷新</a-button>
              <a-button type="primary" class="cancel-btn" @click="back"
                >返回</a-button
              >
            </div>
          </div>
          <div class="service-room-list">
            <div
              v-for="room in roomList"
              :key="room.FloorId"
              class="floor-list"
            >
              <div
                v-for="item in room.Data"
                :key="item.Id"
                class="room-item"
                @click="chooseRoom(item)"
                :style="{ background: item.ClearStatus == 0 ? dirtyColor : '' }"
                :class="{
                  checked: selectRoomIds == item.Id
                }"
              >
                <a-dropdown :trigger="['contextmenu']" style="height:100%">
                  <div>
                    <a-icon type="check-circle" />
                    <div class="room-no">
                      <!-- <span class="icon-tag">
                        <span class="dirty-icon" v-if="item.ClearStatus == 0"
                          >脏</span
                        >
                      </span> -->
                      {{ item.No }}
                      <a-tag
                        :style="backgroundStyle(item)"
                        v-if="item.Status == 2"
                        >维修中</a-tag
                      ><small
                        :style="backgroundStyle(item)"
                        v-if="item.Status == 3"
                        >封房中</small
                      >
                      <small
                        :style="backgroundStyle(item)"
                        v-if="item.Status == 0 && item.OrderStatus == 0"
                        >预抵</small
                      >
                      <small
                        :style="backgroundStyle(item)"
                        v-if="item.Status == 0 && item.OrderStatus == 1"
                        >在住房</small
                      >
                      <small
                        :style="backgroundStyle(item)"
                        v-if="item.Status == 0 && item.OrderStatus == 2"
                        >预离</small
                      >
                    </div>
                    <div>
                      <a-tag v-if="item.StepStatus == 11" color="#199ed8"
                        >{{ item.StepStatusName }}<br />
                        清洁员：{{ item.HandlerName }}<br />
                        {{ moment(item.AccountDate).format("YYYY-MM-DD") }}
                      </a-tag>
                      <a-tag v-if="item.StepStatus == 12" color="#faad14">
                        {{ item.StepStatusName }}<br />
                        清洁员：{{ item.HandlerName }}<br />
                        {{ moment(item.AccountDate).format("YYYY-MM-DD") }}
                      </a-tag>
                      <a-tag v-if="item.StepStatus == 13" color="#ec5b5b">
                        {{ item.StepStatusName }}<br />
                        清洁员：{{ item.HandlerName }}<br />
                        {{ moment(item.AccountDate).format("YYYY-MM-DD") }}
                      </a-tag>
                    </div>
                  </div>
                  <a-menu
                    slot="overlay"
                    v-if="item.StepStatus != 0 && item.ClearStatus == 0"
                  >
                    <a-menu-item
                      key="1"
                      @click="sendPass(item)"
                      v-if="showSendPass"
                    >
                      <a-icon type="arrow-right" />补发密码
                    </a-menu-item>
                    <a-menu-item
                      key="2"
                      @click="chekRemark(item)"
                      v-if="showSendPass"
                    >
                      <a-icon type="search" />查看密码
                    </a-menu-item>
                    <a-menu-item key="3" @click="checkLog(item)">
                      <a-icon type="file-search" />房间日志
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </div>

              <!-- <span
                class="floor-name"
                v-show="room.ShowFloorName && room.FloorName"
                >{{ room.FloorName }}</span
              > -->
            </div>
          </div>
        </a-layout>
        <a-layout-sider
          theme="light"
          class="service-room-search"
          :reverseArrow="true"
          v-model="collapsed"
          collapsible
          :collapsedWidth="0"
          :width="170"
        >
          <div class="search-roomno">
            <input
              class="js_roomNo txt"
              placeholder="房号"
              @keyup="filterData"
            />
            <a-button type="primary" @click="filterData">搜索</a-button>
          </div>
          <div class="item-title">楼层</div>
          <a-checkbox-group
            v-model="floorIds"
            @change="filterData"
            class="floor-name-list"
          >
            <a-checkbox
              :value="item.Id"
              v-for="item in floorData"
              :key="item.Id"
            >
              {{ item.Text }}
            </a-checkbox>
          </a-checkbox-group>
        </a-layout-sider>
      </a-layout>
    </a-spin>
  </div>
</template>
<script>
import { cache } from "@/utils/common";
import { AppointCleanerModal, RoomUpdateModal } from "./index.js";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
export default {
  components: {},
  props: {},
  data() {
    return {
      moment,
      user: {},
      // eslint-disable-next-line no-undef
      versionConfig,
      collapsed: false,
      spinning: false,
      floorData: [],
      floorIds: [],
      baseData: [],
      roomList: [],
      selectRoomIds: "",
      allRoomList: [],
      dirtyColor: "",
      roomColors: [],
      canAppointer: true,
      canClean: true,
      canEndClean: true,
      canAccept: true,
      canCancel: true,
      canSetDirty: true,
      showSendPass: false
    };
  },
  computed: {
    backgroundStyle() {
      return function(item) {
        let color = "";
        const { roomColors, dirtyColor } = this;
        if (roomColors && roomColors.length) {
          if (item.Status == 0) {
            //预抵
            color = roomColors.find(el => el.Code == "Arrivals").Data.Color;
            if (item.OrderStatus == 1) {
              //在住
              color = roomColors.find(el => el.Code == "CheckInClean").Data
                .Color;
            } else if (item.OrderStatus == 2) {
              //预离
              color = roomColors.find(el => el.Code == "Departure").Data.Color;
            }
          } else if (item.Status == 2) {
            color = roomColors.find(el => el.Code == "Repair").Data.Color;
          } else if (item.Status == 3) {
            //封房
            color = roomColors.find(el => el.Code == "Lock").Data.Color;
          } else if (item.ClearStatus == 0) {
            color = dirtyColor;
          }
          return {
            background: color,
            color: "#000",
            padding: "0 5px"
          };
        }
      };
    }
  },
  watch: {
    selectRoomIds(val) {
      if (val) {
        this.canAppointer = this.getStatus([0], 0);
        this.canClean = this.getStatus([11]);
        this.canEndClean = this.getStatus([12]);
        this.canAccept = this.getStatus([13]);
        this.canCancel = this.getStatus([11, 12, 13]);
        this.canSetDirty = this.getStatus([0], 1);
      } else {
        this.canAppointer = true;
        this.canClean = true;
        this.canEndClean = true;
        this.canAccept = true;
        this.canCancel = true;
        this.canSetDirty = true;
      }
    }
  },
  created() {
    this.user = cache.get("user");
    this.$post("Common_GetSelect", { Types: "Floor,RoomStatusColor" }).then(
      res => {
        this.floorData = res.Data.Floor;
        this.roomColors = res.Data.RoomStatusColor;
        const emptyDirty = res.Data.RoomStatusColor.find(
          el => el.Code == "EmptyDirty"
        );
        this.dirtyColor =
          emptyDirty && emptyDirty.Data && emptyDirty.Data.Color
            ? emptyDirty.Data.Color
            : "#a9a9a9";
      }
    );
    this.$post("Room_GetDefaultTime", {}).then(res => {
      const json = {};
      res.Data.SystemConstList.forEach(item => {
        json[item.Code] = item.Value;
      });
      const lockConfig = JSON.parse(json.YunDingLock);
      if (!lockConfig.client_id && !lockConfig.client_secret) {
        this.showSendPass = false;
      } else {
        this.showSendPass = true;
      }
    });
    this.getData();
  },
  destroyed() {},
  mounted() {},
  methods: {
    getStatus(stepStatus, clearStatus) {
      let rooms = this.baseData.filter(el =>
        stepStatus.includes(el.StepStatus)
      );
      if (clearStatus != undefined) {
        rooms = rooms.filter(el => el.ClearStatus == clearStatus);
      }
      if (rooms && rooms.length) {
        const roomsIds = rooms.map(v => v.Id);
        if (roomsIds.includes(this.selectRoomIds)) {
          return true;
        }
      }
      return false;
    },
    getData() {
      this.spinning = true;
      return new Promise((resolve, reject) => {
        this.$post("GetCleanRoomStatus", {})
          .then(res => {
            this.spinning = false;
            this.baseData = res.Data.CleanRoomStatusDetails;
            this.roomList = res.Data.CleanRoomStatusDetails;
            let list = [];
            res.Data.CleanRoomStatusDetails.forEach((el, index) => {
              var last = list[list.length - 1];
              const json = {
                FloorId: el.FloorId,
                FloorName: el.FloorName,
                ShowFloorName: false,
                Data: [el]
              };
              if (!index) {
                list.push(json);
              } else if (last && el.FloorId === last.FloorId) {
                last.Data.push(el);
              } else {
                list.push(json);
              }
            });
            this.roomList = list;
            this.allRoomList = cloneDeep(this.roomList);
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    filterData() {
      let data = cloneDeep(this.allRoomList);
      if (this.floorIds && this.floorIds.length) {
        data = this.allRoomList.filter(el =>
          this.floorIds.includes(el.FloorId)
        );
      }
      const roomNo = document.querySelector(".js_roomNo").value;
      if (roomNo && roomNo.length > 1) {
        const cloneData = cloneDeep(data);
        cloneData.forEach(el => {
          el.Data = el.Data.filter(el => el.No.includes(roomNo));
        });
        data = cloneData;
        // data = data.filter(el => el.No.includes(roomNo));
      }
      this.roomList = data;
    },
    hoverEvent(e, item) {
      if (item) {
        item.ShowFloorName = true;
      }
    },
    leaveEvent(e, item) {
      if (item) {
        item.ShowFloorName = false;
      }
    },
    chooseRoom(item) {
      this.selectRoomIds = this.selectRoomIds == item.Id ? "" : item.Id;
    },
    appointCleaner() {
      const dirtyRooms = this.baseData.filter(el => el.ClearStatus == 0);
      if (dirtyRooms && dirtyRooms.length) {
        AppointCleanerModal({
          selectIds: this.selectRoomIds ? [this.selectRoomIds] : [],
          stepStatus: [0],
          filterClearStatus: true,
          type: "appoint",
          data: this.baseData,
          update: () => {
            this.updateData();
          }
        });
      } else {
        this.$message.error("没有脏房");
      }
    },
    sendPass(item) {
      this.$post("SendPasswordAgain", { Id: item.RoomLogId }).then(() => {
        this.$message.success("操作成功");
      });
    },
    chekRemark(item) {
      this.$info({
        title: item.Remark
      });
    },
    checkLog(item) {
      RoomUpdateModal({
        option: item,
        roomNos: [],
        showButtons: false
      });
    },
    startClean() {
      AppointCleanerModal({
        selectIds: this.selectRoomIds ? [this.selectRoomIds] : [],
        type: "startClean",
        stepStatus: [11],
        data: this.baseData,
        update: () => {
          this.updateData();
        }
      });
    },
    endClean() {
      AppointCleanerModal({
        selectIds: this.selectRoomIds ? [this.selectRoomIds] : [],
        type: "endClean",
        stepStatus: [12],
        data: this.baseData,
        update: () => {
          this.updateData();
        }
      });
    },
    acceptClean() {
      AppointCleanerModal({
        selectIds: this.selectRoomIds ? [this.selectRoomIds] : [],
        type: "accept",
        stepStatus: [13],
        data: this.baseData,
        update: () => {
          this.updateData();
        }
      });
    },
    cancelClean() {
      AppointCleanerModal({
        selectIds: this.selectRoomIds ? [this.selectRoomIds] : [],
        type: "cancelClean",
        stepStatus: [11, 12, 13],
        data: this.baseData,
        update: () => {
          this.updateData();
        }
      });
    },
    setDirty() {
      AppointCleanerModal({
        selectIds: this.selectRoomIds ? [this.selectRoomIds] : [],
        type: "setDirty",
        clearStatus: 1,
        filterClearStatus: true,
        stepStatus: [0],
        data: this.baseData,
        update: () => {
          this.updateData();
        }
      });
    },
    updateData() {
      this.getData().then(() => {
        this.selectRoomIds = "";
        this.filterData();
      });
    },
    reflesh() {
      this.selectRoomIds = "";
      document.querySelector(".js_roomNo").value = "";
      this.floorIds = [];
      this.getData();
    },
    back() {
      this.$router.push({ name: "TodayRoomStatus" });
    }
  }
};
</script>
<style lang="less" scoped>
.service-room-box {
  height: calc(100vh - 125px);
  .operater-section {
    height: 42px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 7px;
    display: flex;
    justify-content: space-between;
    button {
      margin-right: 10px;
    }
    .cancel-btn {
      background: #ff8141;
      color: #fff;
      border-color: #ff8141;
      &:hover,
      &:focus,
      &:active {
        background: #f50;
        border-color: #f50;
        color: #fff;
      }
    }
  }
  .service-room-list {
    overflow-x: hidden;
    height: calc(100vh - 175px);
    overflow-y: auto;
    .floor-list {
      // overflow: hidden;
      .floor-name {
        font-size: 15px;
        float: left;
        margin-top: 12px;
        color: #fff;
        font-weight: bold;
        display: block;
        width: 48px;
        height: 48px;
        line-height: 48px;
        text-align: center;
        background: #4aa3f6;
        border-radius: 100%;
      }
    }
    .room-item {
      float: left;
      width: 135px;
      height: 84px;
      margin: 2px;
      background: #fff;
      position: relative;
      box-sizing: border-box;
      text-align: center;
      .room-no {
        font-size: 14px;
        position: relative;
      }
      .account-date {
        font-size: 12px;
        position: absolute;
        left: 3px;
        bottom: 0;
        color: #fff;
      }
      .ant-tag {
        margin-right: 0;
        // border-radius: 100%;
        // width: 24px;
        // height: 24px;
        height: auto;
        padding: 0 5px;
        line-height: 18px;
        text-align: center;
      }
      i {
        display: none;
        position: absolute;
        font-size: 40px;
        color: #fff;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
      }
      .icon-tag {
        position: absolute;
        left: 2px;
        top: 2px;
      }
      .dirty-icon {
        width: 18px;
        height: 18px;
        border: 1px solid #818181;
        border-radius: 100%;
        line-height: 15px;
        text-align: center;
        font-size: 12px;
        color: #646464;
        background: #fff;
        padding: 0;
        display: inline-block;
        vertical-align: 4px;
      }
      // &.dirty {
      // background: #a9a9a9;
      // }
      &.checked {
        background: #bae4f9 !important;
        i {
          display: block;
        }
      }
    }
  }
  .service-room-search {
    padding-left: 10px;
    /deep/.ant-checkbox-wrapper {
      display: block;
      margin-left: 0;
    }
    .item-title {
      background: #30abca;
      padding-left: 5px;
      color: #fff;
      margin-bottom: 2px;
    }
    .search-roomno {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-around;
      width: 100%;
    }
    .txt {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      position: relative;
      display: inline-block;
      padding: 4px 11px;
      width: 100%;
      height: 32px;
      font-size: 14px;
      line-height: 1.5;
      color: rgba(0, 0, 0, 0.65);
      background-color: #fff;
      background-image: none;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
      margin-right: 5px;
      &:focus {
        border: 1px solid #40a9ff;
        outline: none;
      }
    }
  }
  .floor-name-list {
    height: calc(100vh - 192px);
    overflow: hidden;
    overflow-y: auto;
    width: 100%;
  }
}
.zy-service-container {
  .service-room-box .service-room-search .item-title {
    background: #5b7eab;
  }
}
</style>
